import { FC, useRef } from "react";
import { useLocation } from "react-router-dom";

import SelectedMenuSessionVariable from "@app/layout/menus/constants";
import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import { useIsOverflow } from "@app/shared/qes-standards/utility/useIsOverflow";
import TooltipWrapper from "@app/shared/TooltipWrapper";

import { removeLocalStorageRunConfigurationById } from "@app/velvet/helpers";

/** Defines the required props to render a "standard" (non-SPA) link. */
interface MegaMenuStandardLinkProps {
  faIcon: string;
  menuItem?: MenuItemEnum;
  target?: "_blank" | "_self" | "_parent" | "_top";
  linkText: string;
  to: string;
}

/** Represents a "standard" (non-SPA) link for use in the mega menu. */
const MegaMenuStandardLink: FC<React.PropsWithChildren<MegaMenuStandardLinkProps>> = ({ faIcon, menuItem, target, linkText, to }: MegaMenuStandardLinkProps) => {
  const selectedMenuItemSessionValue = sessionStorage.getItem(SelectedMenuSessionVariable);
  const selectedMenuItem = selectedMenuItemSessionValue ? selectedMenuItemSessionValue as MenuItemEnum : MenuItemEnum.Unknown;
  const isSelected = menuItem && selectedMenuItem === menuItem;
  const linkRef = useRef(null);
  const showTooltip = useIsOverflow(linkRef);
  const location = useLocation();

  // This method ensures that when the user leaves the project and comes back, they are redirected to the most recent time-slice
  const handleClick = (): void => {
    const url = location.pathname;
    const regex = /\/projects\/(\d+)\//;
    const match = url.match(regex);
    if (match) {
      const projectId = Number(match[1]);
      if (!isNaN(projectId)) {
        removeLocalStorageRunConfigurationById(projectId);
      }
    }
  };

  return (
    <li className="menu-item">
      <TooltipWrapper text={showTooltip ? linkText : ""} triggerWidth="100%" position="right">
        <a ref={linkRef} className={`menu-link${isSelected ? " selected-menu-item" : ""}`} href={to} target={target ? target : ""} id={`menu__menu-standard-link--${menuItem}`} onClick={handleClick}>
          <i className={`menu-icon fa fa-${faIcon}${isSelected ? " selected-menu-item" : ""}`} />
          {linkText}
        </a>
      </TooltipWrapper>
    </li>
  );
};

export default MegaMenuStandardLink;
